var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgJoinIcon = function SvgJoinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 35V33.25C1.75 30.0011 3.04062 26.8853 5.33794 24.5879C7.63526 22.2906 10.7511 21 14 21C17.2489 21 20.3647 22.2906 22.6621 24.5879C24.9594 26.8853 26.25 30.0011 26.25 33.25V35",
    stroke: "#B472DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 24.5C22.75 22.1794 23.6719 19.9538 25.3128 18.3128C26.9538 16.6719 29.1794 15.75 31.5 15.75C32.6491 15.75 33.7869 15.9763 34.8485 16.4161C35.9101 16.8558 36.8747 17.5003 37.6872 18.3128C38.4997 19.1253 39.1442 20.0899 39.5839 21.1515C40.0237 22.2131 40.25 23.3509 40.25 24.5V25.375",
    stroke: "#B472DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21C15.8565 21 17.637 20.2625 18.9497 18.9497C20.2625 17.637 21 15.8565 21 14C21 12.1435 20.2625 10.363 18.9497 9.05025C17.637 7.7375 15.8565 7 14 7C12.1435 7 10.363 7.7375 9.05025 9.05025C7.7375 10.363 7 12.1435 7 14C7 15.8565 7.7375 17.637 9.05025 18.9497C10.363 20.2625 12.1435 21 14 21ZM31.5 15.75C32.8924 15.75 34.2277 15.1969 35.2123 14.2123C36.1969 13.2277 36.75 11.8924 36.75 10.5C36.75 9.10761 36.1969 7.77226 35.2123 6.78769C34.2277 5.80312 32.8924 5.25 31.5 5.25C30.1076 5.25 28.7723 5.80312 27.7877 6.78769C26.8031 7.77226 26.25 9.10761 26.25 10.5C26.25 11.8924 26.8031 13.2277 27.7877 14.2123C28.7723 15.1969 30.1076 15.75 31.5 15.75Z",
    stroke: "#B472DD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgJoinIcon;